import { useCallback, useRef } from "react";
import { useConfig } from '../../contexts';
import { RemainingTimer } from "../Shared";
import { logout } from '../../utilities/authentication';
import Swal from 'sweetalert2';
import { millisToHoursAndMinutesAndSeconds } from "../../utilities/time";
import { IUseIdleReturn } from "../../hooks/useIdle.hook";
import { requestRefreshToken } from "../../services";

export default function SessionRemainingTimer() {
    const { state: {
        expiryInSecond,
        promptExpiryInSecond,
        refreshCooldownMilliseconds,
        throttleInMilliseconds
    } } = useConfig();

    const lastRefreshAt = useRef<number>(0);

    const handleLogOut = () => {
        logout()
    };

    const handlePrompt = async (onReset: () => void) => {
        let result = await Swal.fire({
            title: 'Your session is almost expired',
            text: 'What would you like to do?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Stay signed in',
            cancelButtonText: 'Sign out'
        });

        if (result.isConfirmed || result.dismiss === Swal.DismissReason.backdrop) {
            await requestRefreshToken();
            onReset();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            handleLogOut();
        }
    };

    const updateButtonText = (isPrompted: IUseIdleReturn['isPrompted'], remainingTime: ReturnType<IUseIdleReturn['getRemainingTime']>) => {
        if (!isPrompted()) return
        Swal.update({
            confirmButtonText: `Stay signed in : ${millisToHoursAndMinutesAndSeconds(remainingTime)}`,
        });
    }

    const handleAction = useCallback(async () => {
        if (!localStorage.getItem('refreshToken')) return;
        if (Date.now() - lastRefreshAt.current < refreshCooldownMilliseconds) return;

        const refreshed = await requestRefreshToken();
        if (refreshed) lastRefreshAt.current = Date.now();
    }, [refreshCooldownMilliseconds, throttleInMilliseconds]);

    return <RemainingTimer
        expiryInSecond={expiryInSecond}
        promptExpiryInSecond={promptExpiryInSecond}
        hidden={true}
        onIdle={handleLogOut}
        onPrompt={handlePrompt}
        onInterval={updateButtonText}
        throttle={throttleInMilliseconds}
        onAction={handleAction}
    />

    // return (
    //     <Stack direction={'row'} justifyContent={'flex-end'}>
    //         <Typography>
    //             Session will expire in:
    //             <RemainingTimer
    //                 expiryInSecond={expiryInSecond}
    //                 promptExpiryInSecond={promptExpiryInSecond}
    //                 onIdle={handleLogOut}
    //                 onPrompt={handlePrompt}
    //                 onInterval={updateButtonText}
    //                 throttle={throttleInMilliseconds}
    //                 onAction={handleAction}
    //             />
    //         </Typography>
    //     </Stack>
    // );
}